const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
  {
    key: 'Id',
    field: 'id',
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 50,
  },
  {
    key: 'Code',
    field: 'code',
    title: 'Code',
    label: 'Code',
    sortable: true,
    hidden: false,
    width: 150,
  }, {
    key: 'Description',
    field: 'description',
    title: 'Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 300,
  },
  {
    field: 'deletecommands',
    title: '',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];
export default defaultFields;
